<template>
  <div
    v-if="icon && showing === 'svg'"
    id="code-snippet-svg"
    class="code-snippet-tab"
    role="tabpanel"
    aria-labelledby="tab-svg"
  >
    <wa-code-block
      add-highlighting
      allow-shadow-copy
      copy-text="Copy Code Snippet"
      custom-copy-icon="faClone"
      copy-tracking-event="icon_svg_code_copy_button_click"
      :copy-tracking-params="{ icon_name: icon.name, icon_style: styling.style, icon_family: styling.family }"
      lang="svg"
      :code="modifiedSvg"
    />

    <icon-code-snippet-links
      :has-custom-styling="hasCustomStyling"
      :links="svgLearnAboutLinks"
      :selected-style="styling.style"
      :version="version"
    />
  </div>
</template>

<script>
  import IconCodeSnippetLinks from './IconCodeSnippetLinks'
  import { svgStylingDifference, svgCodeSnippet } from './utils'

  export default {
    name: 'IconCodeSnippetSvg',

    components: {
      IconCodeSnippetLinks
    },

    props: {
      activeVersion: {
        required: false
      },
      defaultStyles: {
        type: Object
      },
      icon: {
        type: Object
      },
      iconAbstract: {
        type: Object
      },
      hasCustomStyling: {
        type: Boolean
      },
      showing: {
        required: false
      },
      styling: {
        type: Object
      },
      svgSource: {
        type: String
      },
      version: {
        type: Number
      },
      viggo: {
        validator(value) {
          return !!value && !!value.SVG
        }
      }
    },

    computed: {
      svgLearnAboutLinks() {
        const label = 'Using Icons as Bare SVGs'

        const path = this.version === 5 ? '/web/advanced/svg-sprites' : '/web/add-icons/svg-bare'

        return [{ label, path }]
      },

      modifiedSvg() {
        if (!this.iconAbstract) {
          return ''
        }

        const colors = svgStylingDifference(this.styling, this.defaultStyles)
        const iconLicenseType = this.icon?.is_free ? 'Free' : 'Pro'
        const codeSnippet = svgCodeSnippet(this.viggo, this.iconAbstract, colors, iconLicenseType)

        return codeSnippet
      }
    },

    methods: {
      async copySvg() {
        this.$emit('copySvg')
      }
    }
  }
</script>
